import React, { Component } from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import { connect } from "react-redux";
import settings from "../../settings";
import PersonDetail from "./Platinum/PersonDetail";
import PlatinumAddressHistory from "./Platinum/PlatinumAddressHistory";
import UCCFiling from "./Platinum/UCCFiling";
import Associates from "./Platinum/Associates";
// import DriverLiencesDetails from "./Platinum/DriverLiencesDetails";
import VoterRegistrations from "./Platinum/VoterRegistrations";
import Relatives from "./Platinum/Relatives";
import ConcealedWeaponsPermits from "./Platinum/ConcealedWeaponsPermits";
import ProfessionalLicenses from "./Platinum/ProfessionalLicenses";
import EmailReportSection from "./EmailReportSection";
// import CriminalRecordsPrimarySource from "./Platinum/CriminalRecordsPrimarySource";
import {
  stickyNavInitialize,
  stickyNavInitializeContext,
} from "../../actions/stickyNavAction";
import ShowAllElements from "./Silver/ShowAllElements";
// import MotorVehiclesSilverReport from "./Silver/MotorVehiclesSilverReport";
import HuntingPermits from "./Silver/HuntingPermits";
// import BankLiensJudgmentsReportSection from "./Silver/BankLiensJudgmentsReportSection";
import SsnVerificationSection from "./SsnVerificationSection";
import NeighborsGold from "./Platinum/NeighborsGold";
import CriminalReportSection from "./CriminalReportSection";
import BankruptciesLiensJudgmentsReportSection from "./BankruptciesLiensJudgmentsReportSection";
import MotorVehicleReportSection from "./MotorVehicleReportSection";

class PersonGoldReport extends Component {
  constructor(props) {
    super(props);
    this.reportRefs = [];
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      savedResultID,
      internalID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentIndex !== undefined) {
      this.onReportIndexChanged(nextProps.currentIndex);
    }
    if (nextProps.additionalData !== null) {
      this.loadData(nextProps);
    }
  }

  onReportIndexChanged = (currentIndex) => {
    const reportRef = this.reportRefs[
      currentIndex < this.reportRefs.length ? currentIndex : 0
    ];
    const section = ReactDOM.findDOMNode(reportRef.current);
    if (section !== undefined && section !== null) {
      section.scrollIntoView();
    } else if (this.state.navs && this.state.navs.length > currentIndex) {
      const nav = this.state.navs[currentIndex];
      const element = document.getElementById(`nav_${nav.name}`);
      if (element) element.scrollIntoView();
    }
  };

  loadData = (props) => {
    if (this.state.navs) return;

    const navs = [];
    this.reportRefs = [];
    let reportTypes = settings.compGoldDefaultReportTypes;
    if (
      props.additionalData !== undefined &&
      props.additionalData.optReportType === "compplus"
    ) {
      reportTypes = settings.compPlusDefaultReportTypes;
    }
    const navRefMap = {};
    const defRef = React.createRef();
    navRefMap[settings.defaultSection.sectionName] = {
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      ref: defRef,
    };
    navs.push({
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      count: undefined,
    });
    this.reportRefs.push(defRef);

    _.forEach(settings.sectionReports, (rep) => {
      if (_.findIndex(reportTypes, (a) => a === rep.sectionName) !== -1) {
        const ref = React.createRef();
        navRefMap[rep.sectionName] = {
          name: rep.sectionName,
          display: rep.displayName,
          ref,
        };
        navs.push({
          name: rep.sectionName,
          display: rep.displayName,
          count: undefined,
        });
        this.reportRefs.push(ref);
      }
    });
    _.forEach(settings.sectionReports, (rep) => {
      if (_.findIndex(settings.compNewGoldAdditionalReportTypes, (a) => a === rep.sectionName) !== -1) {
        const ref = React.createRef();
        navRefMap[rep.sectionName] = {
          name: rep.sectionName,
          display: rep.displayName,
          ref,
        };
        navs.push({
          name: rep.sectionName,
          display: rep.displayName,
          count: undefined,
        });
        this.reportRefs.push(ref);
      }
    });
    const addonReports = props.additionalData.selectedReports
      ? props.additionalData.selectedReports
      : [];
    _.forEach(settings.addOnReports, (addonReport) => {
      const addonNode = _.get(
        props.reportData,
        `personReport.${addonReport.sectionName}s[0]`
      );
      if (addonNode) {
        addonReports.push(addonReport.sectionName);
      }
    });
    const addonReportSections = [];
    if (addonReports !== undefined && addonReports.length > 0) {
      const addOnref = React.createRef();
      navRefMap.addonrepsep = {
        name: "addonrepsep",
        display: "Add On Reports",
        ref: addOnref,
      };
      navs.push({
        name: "addonrepsep",
        display: "Add On Reports",
        count: undefined,
      });
      this.reportRefs.push(addOnref);
      _.forEach(settings.addOnReports, (rep) => {
        if (_.findIndex(addonReports, (a) => a === rep.sectionName) !== -1) {
          const ref = React.createRef();
          navRefMap[rep.sectionName] = {
            name: rep.sectionName,
            display: rep.displayName,
            ref,
            count: undefined,
          };
          this.reportRefs.push(ref);
          navs.push({
            name: rep.sectionName,
            display: rep.displayName,
            count: undefined,
          });
        }
      });
      const reportRoot = _.get(
        props.reportData,
        "personReport.response[0].output[0].extendedReports[0].extendedReport[0]"
      );
      if (addonReports.length > 0) {
        for (let i = 0; i < addonReports.length; i += 1) {
          if (addonReports[i] === "crimaddon") {
            // addonReportSections.push(
            //   <CriminalRecordsPrimarySource
            //     ref={navRefMap.crimaddon && navRefMap.crimaddon.ref}
            //     {...this.props}
            //     sectionName={navRefMap.crimaddon && navRefMap.crimaddon.name}
            //     node={_.get(reportRoot, "criminalRecords[0].criminal")}
            //     updateItemCountBySection={this.updateItemCountBySection}
            //     key={`addon_${i}`}
            //   />
            // );
            addonReportSections.push(
              <CriminalReportSection
                ref={navRefMap.crimaddon && navRefMap.crimaddon.ref}
                {...props}
                node={reportRoot}
                sectionName={navRefMap.crimaddon.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "bljaddon") {
            // addonReportSections.push(
            //   <BankLiensJudgmentsReportSection
            //     ref={navRefMap.bljaddon && navRefMap.bljaddon.ref}
            //     {...this.props}
            //     sectionName={navRefMap.bljaddon && navRefMap.bljaddon.name}
            //     key={`addon_${i}`}
            //     reportRoot={reportRoot}
            //     updateItemCountBySection={this.updateItemCountBySection}
            //   />
            // );
            addonReportSections.push(
              <BankruptciesLiensJudgmentsReportSection
                ref={navRefMap.bljaddon && navRefMap.bljaddon.ref}
                {...props}
                node={reportRoot}
                sectionName={navRefMap.bljaddon && navRefMap.bljaddon.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "mvraddon") {
            // addonReportSections.push(
            //   <MotorVehiclesSilverReport
            //     ref={navRefMap.mvraddon && navRefMap.mvraddon.ref}
            //     {...this.props}
            //     level={4}
            //     sectionName={navRefMap.mvraddon && navRefMap.mvraddon.name}
            //     sectionTitle={navRefMap.mvraddon && navRefMap.mvraddon.display}
            //     node={reportRoot}
            //     key={`addon_${i}`}
            //     updateItemCountBySection={this.updateItemCountBySection}
            //   />
            // );
            addonReportSections.push(
              <MotorVehicleReportSection
                ref={navRefMap.mvraddon && navRefMap.mvraddon.ref}
                {...props}
                node={reportRoot}
                sectionName={navRefMap.mvraddon && navRefMap.mvraddon.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          }
        }
      }
    }

    const { internalID, savedResultID } = props.additionalData;
    this.setState({
      reportTypes,
      navRefMap,
      internalID,
      savedResultID,
      navs,
      addonReportSections,
    });
    const stickyNav = props.stickyNav;
    stickyNav.navs = navs;
    props.stickyNavInitialize(stickyNav);
    this.onReportIndexChanged(1);
  };

  redirectToSearch = () => {
    // this.props.history.back();
    // window.history.back();
    // window.location.reload();
    if (window.location.href.indexOf("/search/history") === -1) {
      this.props.history.push("/search/history");
    } else {
      window.location.reload();
    }
  };

  redirectToMoreDetails = () => {
    if (
      window.location.href.indexOf("/search/history") === -1 &&
      localStorage.moreDetailsHistoryReportId
    ) {
      // this.props.history.push("/search/history");
      // } else if (localStorage.moreDetailsHistoryReportId) {
      localStorage.historyReportId = localStorage.moreDetailsHistoryReportId;
      localStorage.historyCriteria = localStorage.moreDetailsHistoryCriteria;
      localStorage.xmlId = localStorage.moreDetailsXmlId;
      window.location.reload();
    }
  };

  updateItemCountBySection = (sectionName, count) => {
    const stickyNav = this.props.stickyNav;
    const navs = stickyNav.navs;
    const currentSection = _.find(navs, (n) => n.name === sectionName);
    if (currentSection !== undefined) {
      currentSection.count = count;
    }
    stickyNav.navs = navs;

    this.props.stickyNavInitializeContext(stickyNav);
  };

  render() {
    const { reportData } = this.props;
    // const personResult = _.get(reportData, "personReport.person[0]");
    let navRefMapLength = 0;
    if (this.state !== null && this.state.navRefMap !== undefined) {
      navRefMapLength = Object.keys(this.state.navRefMap).length;
    }
    const reportRoot = _.get(
      reportData,
      "personReport.response[0].output[0].extendedReports[0].extendedReport[0]"
    );
    return (
      <div ref={this.props.stickyNav.handleContextRef} id={`report`}>
        {/* {window.location.href.indexOf("/search/history") === -1 &&
          localStorage.historyReportId !== "" &&
          localStorage.xmlId !== "" && (
            <button
              className="ui button float-right margin-top-botton-5 no-print margin-right-15"
              onClick={this.redirectToSearch}
            >
              Search Results
            </button>
          )}
        {window.location.href.indexOf("/search/history") === -1 &&
          localStorage.moreDetailsHistoryReportId &&
          localStorage.historyReportId !== "" &&
          localStorage.xmlId !== "" && (
            <button
              className="ui button float-right margin-top-botton-5 no-print margin-right-15 margin-left-10"
              onClick={this.redirectToMoreDetails}
            >
              Back
            </button>
          )} */}
        {this.state && this.state.navRefMap && (
          <div>
            <PersonDetail
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap[settings.defaultSection.sectionName]
                    .ref
                  : undefined
              }
              {...this.props}
              reportData={reportData}
            />
            <PlatinumAddressHistory
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.addresshistory.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.addresshistory.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <SsnVerificationSection
              {...this.props}
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.ssnverification.ref
                  : undefined
              }
              node={reportRoot}
              sectionName={this.state.navRefMap.ssnverification.name}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Associates
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.associates.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.associates.name}
              sectionTitle={this.state.navRefMap.associates.display}
              node={_.get(reportRoot, "associates[0].associate")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.businessAssociations.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.businessAssociations.name}
              sectionTitle={this.state.navRefMap.businessAssociations.display}
              node={_.get(reportRoot, "businessAssociations[0].business")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.corporateFilings.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.corporateFilings.name}
              sectionTitle={this.state.navRefMap.corporateFilings.display}
              node={_.get(reportRoot, "corporateFilings[0].corporation")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            {/* <DriverLiencesDetails
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.driverLicense.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.driverLicense.name}
              node={[reportRoot]}
              updateItemCountBySection={this.updateItemCountBySection}
            /> */}
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.criminal.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.criminal.name}
              sectionTitle={this.state.navRefMap.criminal.display}
              node={_.get(reportRoot, "criminalRecords[0].criminal")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <EmailReportSection
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.email.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.email.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.employers.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.employers.name}
              sectionTitle={this.state.navRefMap.employers.display}
              node={_.get(reportRoot, "employers[0].employer")}
              updateItemCountBySection={this.updateItemCountBySection}
            />

            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.evictions.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.evictions.name}
              sectionTitle={this.state.navRefMap.evictions.display}
              node={_.get(reportRoot, "evictions[0].eviction")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.aircraft.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.aircraft.name}
              sectionTitle={this.state.navRefMap.aircraft.display}
              node={_.get(reportRoot, "aircrafts[0].aircraft")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <HuntingPermits
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.huntingPermits.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.huntingPermits.name}
              node={_.get(reportRoot, "huntingPermits[0].huntingPermit")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <NeighborsGold
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.neighbors.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.neighbors.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />

            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.pilotLicenses.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.pilotLicenses.name}
              sectionTitle={this.state.navRefMap.pilotLicenses.display}
              node={_.get(reportRoot, "pilotLicenses[0].pilotLicense")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Associates
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.possibleAssociates.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.possibleAssociates.name}
              sectionTitle={this.state.navRefMap.possibleAssociates.display}
              node={_.get(
                reportRoot,
                "possibleAssociates[0].possibleAssociate"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.professionalAssociations.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.professionalAssociations.name}
              sectionTitle={
                this.state.navRefMap.professionalAssociations.display
              }
              node={_.get(
                reportRoot,
                "professionalAssociations[0].professionalAssociation"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ProfessionalLicenses
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.professionallicenses.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.professionallicenses.name}
              node={_.get(
                reportRoot,
                "professionalLicenses[0].professionalLicense"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.properties.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.properties.name}
              sectionTitle={this.state.navRefMap.properties.display}
              node={_.get(reportRoot, "currentProperties[0].property")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.pastProperties.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.pastProperties.name}
              sectionTitle={this.state.navRefMap.pastProperties.display}
              node={_.get(reportRoot, "pastProperties[0].property")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.propertyForeclosures.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.propertyForeclosures.name}
              sectionTitle={this.state.navRefMap.propertyForeclosures.display}
              node={_.get(
                reportRoot,
                "propertyForeclosures[0].propertyForeclosure"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.propertyTaxes.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.propertyTaxes.name}
              sectionTitle={this.state.navRefMap.propertyTaxes.display}
              node={_.get(reportRoot, "propertyTaxes[0].propertyTax")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Relatives
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.relatives.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.relatives.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.tradeMarks.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.tradeMarks.name}
              sectionTitle={this.state.navRefMap.tradeMarks.display}
              node={_.get(reportRoot, "tradeMarks[0].tradeMark")}
              updateItemCountBySection={this.updateItemCountBySection}
            />

            <UCCFiling
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.ucc.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.ucc.name}
              node={reportRoot}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <VoterRegistrations
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.voterregistrations.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.voterregistrations.name}
              node={_.get(
                reportRoot,
                "voterRegistrations[0].voterRegistration"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.watchListRecords.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.watchListRecords.name}
              sectionTitle={this.state.navRefMap.watchListRecords.display}
              node={_.get(reportRoot, "watchListRecords[0].watchListRecord")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ConcealedWeaponsPermits
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.weapon.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.weapon.name}
              node={_.get(
                reportRoot,
                "concealedWeaponPermits[0].concealedWeaponPermit"
              )}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.wikipediaLinks.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.wikipediaLinks.name}
              sectionTitle={this.state.navRefMap.wikipediaLinks.display}
              node={_.get(reportRoot, "wikipediaLinks[0].wikipediaLink")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.vehicles.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.vehicles.name}
              sectionTitle={this.state.navRefMap.vehicles.display}
              node={_.get(reportRoot, "vehicles[0].vehicle")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.liensOnly.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.liensOnly.name}
              sectionTitle={this.state.navRefMap.liensOnly.display}
              node={_.get(reportRoot, "personalLienFilings[0].personalLienFiling")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.judgmentsOnly.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.judgmentsOnly.name}
              sectionTitle={this.state.navRefMap.judgmentsOnly.display}
              node={_.get(reportRoot, "personalJudgmentFilings[0].personalJudgmentFiling")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ShowAllElements
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.bankOnly.ref
                  : undefined
              }
              {...this.props}
              level={4}
              sectionName={this.state.navRefMap.bankOnly.name}
              sectionTitle={this.state.navRefMap.bankOnly.display}
              node={_.get(reportRoot, "personalBankruptcyFilings[0].personalBankruptcyFiling")}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            {this.state.addonReportSections}
            <br />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentIndex: state.nav.currentIndex,
    stickyNav: state.stickyNav,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  stickyNavInitialize,
  stickyNavInitializeContext,
})(PersonGoldReport);



// WEBPACK FOOTER //
// ./src/components/reports/PersonGoldReport.js